/* eslint-disable react/prop-types */
import InfoIcon from 'Assets/images/commons/info-gray.svg';
import ArrowRight from 'Assets/images/pages/web-chat/arrow.svg';
import { calculateYearsOld } from 'Helpers/consult-utils';
import ConfirmModal from 'Modules/ConfirmModal/ConfirmModal';
import Space from 'Modules/Space';
import { func } from 'prop-types';
import React, { useState } from 'react';
import { Divider, Modal, ModalContent, ModalHeader, Segment } from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';
import { consultResetState, consultSetMainProvider } from 'Redux/modules/webChat/actions';
import { CONSULT_ACCEPTED } from 'Constants/consults';

import styles from './ConsultParticipantsModal.less';
import ParticipantItem from './ParticipantItem';

const ConsultParticipantsModal = ({
  patient,
  forPatient,
  doctor,
  consult,
  doctors = [],
  onClose,
  openPatientInformation,
}) => {
  const { id, status: consultStatus } = consult;

  const viewPatientDetails = () => {
    onClose();
    openPatientInformation();
  };

  const [confirmSetMainProvider, setConfirmSetMainProvider] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const dispatch = useDispatch();

  const {
    consults: { status, error },
  } = useSelector(state => state.webChat);

  const { data: doctorProfile } = useSelector(state => state.webChat.doctor);

  const toggleOpenConfirmSetMainProvider = () => {
    setConfirmSetMainProvider(!confirmSetMainProvider);
    dispatch(consultResetState());
  };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleSetMainProvider = async () => {
    if (selectedDoctor)
      await dispatch(
        consultSetMainProvider(doctor.id, id, {
          doctorId: selectedDoctor.id,
        }),
      );
    toggleOpenConfirmSetMainProvider();
    onClose();
  };

  const genPatientDesc = ({ genderAtBirth = '', dateOfBirth }) => {
    const genderText = genderAtBirth ? `${genderAtBirth}, ` : '';
    return `${genderText}${calculateYearsOld(dateOfBirth)}`;
  };

  const handleSelectMainProvider = dr => {
    setSelectedDoctor(dr);
    toggleOpenConfirmSetMainProvider();
  };

  const isGoingConsult = consultStatus === CONSULT_ACCEPTED;
  // for sort main doctor is the first
  const provides = [doctor, ...doctors.filter(d => d.id !== doctor.id)];
  return (
    <Modal open size="small" closeIcon onClose={onClose} className={styles.modalMainProvider}>
      <ModalHeader>Consultation Participants</ModalHeader>
      <ModalContent>
        <Space direction="vertical" size={4}>
          <Segment>
            <div className={styles.label}>Patient</div>
            <Space
              direction="horizontal"
              size={12}
              width="100%"
              justify="space-between"
              cursor="pointer"
              onClick={viewPatientDetails}>
              <ParticipantItem
                fullName={forPatient.fullName}
                desc={genPatientDesc(forPatient)}
                avatarUrl={forPatient.avatarUrl ?? ''}
              />
              <img src={ArrowRight} alt="arrow" />
            </Space>
          </Segment>
          <Segment>
            <div className={styles.label}>Consult Requested by</div>
            <ParticipantItem
              fullName={patient.fullName}
              desc={genPatientDesc(patient)}
              avatarUrl={patient.avatarUrl ?? ''}
            />
          </Segment>
          <Segment>
            <div className={styles.label}>Providers</div>
            {provides.map(provider => (
              <div key={provider.id}>
                <ParticipantItem
                  fullName={provider.fullName}
                  desc={provider.title}
                  isMain={provider.id === doctor.id}
                  avatarUrl={provider.avatarUrl}
                  confirmSetMainProvider={() => handleSelectMainProvider(provider)}
                  isEligibleToSetMainProvider={
                    doctor.id === doctorProfile.id && provider.id !== doctor.id && isGoingConsult
                  }
                />
                <Divider />
              </div>
            ))}
            <Space direction="horizontal" alignItems="start" size={12} marginTop={12}>
              <img src={InfoIcon} className="mt-1" alt="info" /> The main provider can end the
              consultation, and their information will be included on the consultation invoice.
            </Space>
          </Segment>
        </Space>
        {confirmSetMainProvider && (
          <ConfirmModal
            showModal
            message={
              <>
                Are you sure you want to set <strong>{selectedDoctor.fullName ?? ''}</strong> as the
                main provider for the consultation? Once confirmed, it will take effect immediately.
              </>
            }
            title="Set Main Provider"
            onClose={toggleOpenConfirmSetMainProvider}
            onSubmit={handleSetMainProvider}
            loading={status.setMainProvider === 0}
            confirmButtonText="Confirm"
            error={error?.setMainProvider}
          />
        )}
      </ModalContent>
    </Modal>
  );
};

export default ConsultParticipantsModal;

ConsultParticipantsModal.propTypes = {
  onClose: func.isRequired,
  openPatientInformation: func.isRequired,
};
